export class ConversionHelper {
  static refactorCode(code: string = '', _amount: number = 0): string {
    const cent: number = 100;
    let inCent: number = _amount * cent;

    const xStr = code.substring(0, code.length - inCent.toString().length);

    return xStr + inCent;
  }

  static getBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'unknown';
    }
  }

  static generateRandomString(len) {
    var text = '';
    var charset = 'abcdefghijklmnopqrstuvwxyz0123456789';
    for (var i = 0; i < len; i++) text += charset.charAt(Math.floor(Math.random() * charset.length));

    return text;
  }

  static conversionsTickersNormalizer(data: []) {
    const dataObj = Object.assign({}, ...data);
    const final = Object.keys(dataObj).map((x) => ({ quote: x, ...dataObj[x] }));
    return final;
  }
}
